import { useRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { Location } from 'history';

const useLastLocation = (): Location | null => {
  const location = useLocation();
  const prevLocationRef = useRef<Location | null>(null);
  const lastLocation = useMemo(() => {
    const previous = prevLocationRef.current;
    prevLocationRef.current = location;
    return previous;
  }, [location]);

  return lastLocation;
};

export default useLastLocation;
